export default class ExtInfoRequestModel {}
